var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 13.0002H23.0001V22.0002H19.0011L18.0009 22.9998H12.0009L11.0001 22.0002H6.9999V10.0002C6.9999 9.44944 7.4493 9.00004 8.0001 9.00004H15V7.00024H8.0001C6.3438 7.00024 5.0001 8.34274 5.0001 10.0002V22.0002H3C3 23.6562 4.3428 25.0002 6 25.0002H24C25.6563 25.0002 27 23.6571 27 22.0002H24.9999V13.0002Z",
    fill: "#264653"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 7.00016V5.99996C24.9998 5.44916 24.5507 4.99976 23.9999 4.99976H17.9999C17.4512 4.99976 17 5.44916 17 5.99996V10.0002C17 10.5486 17.4512 10.9998 17.9999 10.9998H23.9999C24.5507 10.9998 24.9998 10.5486 24.9998 10.0002V8.99996L26.9999 10.9998V4.99976L24.9998 7.00016ZM23 8.99996H18.9998V7.00016H23V8.99996Z",
    fill: "#264653"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 13.0002C14.9999 14.1048 14.1056 15 12.9998 15C11.8943 15 11 14.1048 11 13.0002C11 11.8956 11.8943 10.9998 12.9998 10.9998C14.1056 10.9998 14.9999 11.8956 14.9999 13.0002Z",
    fill: "#264653"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 16.9998L12 17.001C10.3437 17.001 9 18.3441 9 19.9998H17.0001C17.0001 18.3438 15.6582 16.9998 14.0001 16.9998Z",
    fill: "#264653"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoChat);
export default __webpack_public_path__ + "static/media/video-chat.9b71c60b229b1b3d671b52411f79a8f5.svg";
export { ForwardRef as ReactComponent };